import { action, observable } from 'mobx';
import { HttpClient, setMap } from 'Mri.Web.Common';

export class NocServersStore {
    public constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    @action
    public async loadAllAsync(cache = false) {
        const nocServers = await this.httpClient.get<Mri.NocServers.NocServer[]>(`/api/v1/noc-servers`, {
            cache,
        });

        setMap(this.nocServers, nocServers, n => n.serverName);
    }

    @action
    public async loadAsync(name: string) {
        const nocServer = await this.httpClient.get<Mri.NocServers.NocServer>(`/api/v1/noc-servers/${name}`);

        if (nocServer) this.nocServers.set(nocServer.serverName, nocServer);
    }

    @action
    public async createAsync(model: Mri.NocServers.NocServer) {
        const nocServer = await this.httpClient.post<Mri.NocServers.NocServer>(`/api/v1/noc-servers`, model);

        if (nocServer) this.nocServers.set(nocServer.serverName, nocServer);
    }

    @action
    public async deleteAsync(name: string) {
        console.warn('Function is not yet implemented!');
        //await this.httpClient.delete<Mri.NocServers.NocServer>(`/api/v1/display-groups/${name}`);

        //await this.loadAllAsync();
    }

    @action
    public async updateAsync(name: string, model: Mri.NocServers.NocServer) {
        const nocServer = await this.httpClient.put<Mri.NocServers.NocServer>(`/api/v1/noc-servers/${name}`, model);

        if (nocServer) this.nocServers.set(nocServer.serverName, nocServer);
    }

    @action
    public async addDisplayAsync(
        name: string,
        model: Mri.Web.Internal.Controllers.Displays.DisplaySerialNumberListModel
    ) {
        const nocServer = await this.httpClient.post<Mri.NocServers.NocServer>(
            `/api/v1/noc-servers/${name}/displays`,
            model
        );

        if (nocServer) this.nocServers.set(nocServer.serverName, nocServer);
    }

    @action
    public async removeDisplayAsync(
        name: string,
        model: Mri.Web.Internal.Controllers.Displays.DisplaySerialNumberListModel
    ) {
        const nocServer = await this.httpClient.put<Mri.NocServers.NocServer>(
            `/api/v1/noc-servers/${name}/displays`,
            model
        );

        if (nocServer) this.nocServers.set(nocServer.serverName, nocServer);
    }

    @observable
    public nocServers = new Map<string, Mri.NocServers.NocServer>();

    private readonly httpClient: HttpClient;
}
